module.exports = __webpack_public_path__ + "static/chauffage2-2acf0c7a5045e16639700d5a2e7f2522.jpg";